import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import '../Assets/Css/contact.css';
import contactbanner from '../Assets/Images/Contactusbanner.avif';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import { FaMobileAlt } from "react-icons/fa";

import { toast,Toaster } from 'react-hot-toast';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { BASE_URL } from '../BaseURL';

import { Helmet } from "react-helmet";

export default function Contact() {
    const [formData, setFormData] = useState({
     userName: '',
        email: '',
        mobile:'',
        address:'',
        message: ''
    });

    const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, formData);
      if (response.status === 200) {
        toast.success("Enquiry sent successfully!");
      }
    } catch (error) {
      toast.error("Failed to send enquiry.");
    } finally {
      setLoading(false);
    }
  };

    return (
        <>
        <Toaster/>
            <div className="mainnav">

            <Helmet>
      <title>Contact Us | Sumanik Security And Allied Services Pvt Ltd</title>
      <meta
        name="description"
        content="Get in touch with Sumanik Security for certified and reliable security services across India. Visit our Pune office or reach out via email or phone."
      />
      <meta
        name="keywords"
        content="Contact Sumanik Security, Security Services Pune, Certified Security Company India, Security Guard Enquiry, Security Services Contact Info"
      />
      <meta name="author" content="Sumanik Security And Allied Services Pvt Ltd" />
      <meta property="og:title" content="Contact Us | Sumanik Security Pvt Ltd" />
      <meta
        property="og:description"
        content="Reach out to Sumanik Security for custom security solutions. Visit our Wanwadi, Pune office or connect by phone, email, or contact form."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.sumaniksecurity.com/contact" />
      <meta property="og:image" content="https://www.sumaniksecurity.com/images/contact-og.jpg" />
    </Helmet>
            
                {/* Banner Section */}
                <div className="about-banner position-relative text-white mb-4">
                    <img
                        src={contactbanner}
                        alt="About Banner"
                        className="aboutbanner-image animate-banner-zoom"
                    />
                    <div className="maindesc position-absolute top-50 start-50 translate-middle text-center px-3">
                        <h2 className="fw-bold glitch" data-text=" Contact Us">
                            Contact Us-Sumanik Security and Allied Services Pvt Ltd
                        </h2>
                        
                    </div>
                </div>
           

            {/* Contact Info Section */}
            <Container className="mb-5">
                <Row className="text-center mb-4">
                    <Col>
                        <h2 className="Mainhead">Get in Touch</h2>

                    </Col>
                </Row>
 <Row className="g-4">
    <Col md={6}>
  <Card className="h-100 shadow-sm">
    <Card.Body>
      <h5 className="text-center fw-bold mb-3">Location</h5>

      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
        <MdLocationOn size={35} color="#DCAB34" style={{ marginTop: '3px' }} />
        <p className="mb-1">
          <strong>Office :-</strong> C-9, Twin Tower, Jambhulkar Chowk, Wanwadi, Pune – 411040
        </p>
      </div>

     

      <a
        href="mailto:contact@sumanikservices.com"
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          marginBottom: '10px'
        }}
      >
        <MdEmail size={20} color="#DCAB34" />
        <p className="mb-0"><strong>Email —</strong> contact@sumanikservices.com</p>
      </a>

      <a
        href="https://wa.me/7798737751"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        <FaMobileAlt size={20} color="#DCAB34" />
        <p className="mb-0"><strong>Mobile -</strong>+91 7798737751 </p>
      </a> 

      <div className='mt-3'>
     
      <iframe 
       title="Sumanik Services"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.7593298789134!2d73.8973302751911!3d18.49455758259392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1e080bd01cf%3A0x5bbb4b3ab766a2e3!2sSUMANIK%20SECURITY%20AND%20ALLIED%20SERVICES%20PVT.LTD.!5e0!3m2!1sen!2sin!4v1746273036594!5m2!1sen!2sin"
      width="100%"
       height="350" 
      allowfullscreen="" 
      loading="lazy" 
      referrerpolicy="no-referrer-when-downgrade">
      </iframe>
     </div>

    </Card.Body>
  </Card>
</Col>
    {/* Contact Form */}
       <Col md={6}>
      <Card className="h-100 shadow-sm">
        <Card.Body>
          <h5 className="text-center fw-bold mb-3">Contact Form</h5>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className='fw-bold'>Name</Form.Label>
              <Form.Control
                type="text"
                name="userName"
                value={formData.userName}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />
            </Form.Group>
            <Row>
       <Col lg={6}>
            <Form.Group className="mb-3">
              <Form.Label className='fw-bold'>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </Form.Group>
            </Col>
            <Col lg={6}>
            <Form.Group className="mb-3">
              <Form.Label className='fw-bold'>Mobile</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                value={formData.mobile}
                maxLength={10}
                onChange={handleChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                placeholder="Enter your mobile"
                required
              />
            </Form.Group>
            </Col>
            </Row>

           
            <Form.Group className="mb-3">
              <Form.Label className='fw-bold'>Address</Form.Label>
              <Form.Control
                as="textarea"
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows={2}
                placeholder="Enter your address..."
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className='fw-bold'>Message</Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                placeholder="Your message..."
                required
              />
            </Form.Group>

            <div className="d-grid justify-content-center">
              <Button type="submit" className="contactsubmitbtn" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" /> Sending...
                  </>
                ) : (
                  'Submit'
                )}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Col>
                </Row>

                
            </Container>
            </div>
        </>
    );
}
